import React from 'react';
import Button from '../../atoms/button/button';
import './notLogged.scss';
import alertIcon from '../../../assets/alerta.svg'
import { login } from '../../../shared/src/utils/gigya';

const NotLogged = () => {
	return (
		<div className="mentoria-not-logged-container">
			<div className="mentoria-not-logged-container__background">
				<div className="mentoria-not-logged-container__images">
					<img src={alertIcon} alt="Alerta" className="mentoria-not-logged-container__images__alert" />
				</div>
				<h3 className="mentoria-not-logged-container__subtitle">Para comenzar la mentoria es necesario que inicies sesión</h3>
				<Button
					type='button'
					className="mentoria-not-logged-container__button"
					gtmClass='secondary'
					text='Iniciar Sesión'
					onClick={() => login()}
					disabled={false}
				/>
			</div>
		</div>
	)
}

export default NotLogged